import {
	format,
	getMonth,
	getYear,
	startOfDay,
	endOfDay,
	differenceInYears,
	differenceInMonths,
	differenceInDays,
	differenceInHours,
	differenceInMinutes,
	differenceInSeconds,
	formatDuration,
	intervalToDuration,
} from 'date-fns';
import memoizeOne from 'memoize-one';
import { DATE_FORMAT } from '../model/datetime';

const diffInSwitch = (identifierName = 'years') => {
	const diffInFuncs = {
		years: differenceInYears,
		months: differenceInMonths,
		days: differenceInDays,
		hours: differenceInHours,
		minutes: differenceInMinutes,
		seconds: differenceInSeconds,
	};
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ years: (dateLeft: number | Date, dateRight: number | Date) => number; months: (dateLeft: number | Date, dateRight: number | Date) => number; days: (dateLeft: number | Date, dateRight: number | Date) => number; hours: (dateLeft: number | Date, dateRight: number | Date) => number; minutes: (dateLeft: number | Date, ...'.
	return diffInFuncs[identifierName];
};
export const getToday = memoizeOne((): Date => {
	const date = new Date();
	date.setHours(0, 0, 0, 0);
	return date;
});

export const getCurrentMonth = memoizeOne((today: Date) => getMonth(today));

export const getCurrentYear = memoizeOne((today: Date) => getYear(today));

/**
 *
 * dateISO e.g. 2018-12-01
 * Get miliseconds of UTC
 */

export const getMilisecondFromStartOfDate = (dateISO: string): number => {
	const now = new Date(dateISO);
	return startOfDay(now).valueOf();
};
export const getMilisecondFromEndOfDate = (dateISO: string): number => {
	const now = new Date(dateISO);
	return endOfDay(now).valueOf();
};

export const getDateFromTimestamp = (timestamp: number, dateFormat: string = DATE_FORMAT): string =>
	format(new Date(timestamp), dateFormat);

/**
 * Check if selected date range over the given limit.
 * Default limit is a year.
 * @param {*} startMilliseconds
 * @param {*} endMilliseconds
 * @param {*} limitValue
 * @param {*} limitUnit years | months | days | hours | minutes | seconds
 */
export const getIsDateRangeMoreThanLimit = (
	startMilliseconds: number,
	endMilliseconds: number,
	limitValue = 1,
	limitUnit = 'years',
): boolean => {
	const differenceIn = diffInSwitch(limitUnit);
	const diff = differenceIn(new Date(endMilliseconds), new Date(startMilliseconds));
	return diff >= limitValue;
};

// This is broken with date-fns due to https://codesandbox.io/s/moment-date-fns-difference-ixvjez?file=/src/App.js
export const getDatesDiff = (startDate: number, endDate: number): string => {
	const interval = {
		start: new Date(startDate),
		end: new Date(endDate),
	};
	const duration = intervalToDuration(interval);
	return formatDuration(duration, {
		delimiter: ' ',
	});
};
